














































































/* eslint-disable */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import dayjs from 'dayjs';
import { User } from '@/libs/api.interfaces';
import { mapState } from 'vuex';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import DownloadIcon from 'mdi-vue/Download';
import excel from 'exceljs';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { AxiosError } from 'axios';
@Component({
  components: {
    ScrollbarWrapper,
    Button,
    DownloadIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    LayoutTitle,
    LayoutContent,
    ActionPopup,
  },
  computed: mapState(['user']),
  methods: {
    format,
  },
})
export default class BacthInvoiceDetail extends Vue {
  user!: {
    user: User;
  };
  loading = true;
  loadingExport = false;
  listDetailBacthInvoice: any[] = [];
  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  mounted() {
    this.getBatchInvoiceDetail();
  }

  async getBatchInvoiceDetail() {
    try {
      this.loading = true;
      const idData = `${this.$route.params.id}`;
      const { data } = await api.post('/easyinvoice/invoices_list_batch_detail', {
        /* eslint-disable-next-line @typescript-eslint/camelcase */
        id: idData,
      });
      console.log(data);
      if (data) {
          this.listDetailBacthInvoice = data.data;
          this.totalPage = data.draw;
          this.from = data.draw;
          this.to = data.recordsTotal;
          this.totalItem = data.recordsTotal;
          this.loading = false;
      }
      return null;
    } catch (err) {
      // console.log(err);
      showToast(ToastType.FAILED, 'Oops… Sorry', err.response.data.error.errors[0].message);
      this.loading = false;
      return err as AxiosError;
    }
  }

  async exportData() {
    this.loadingExport = true;
    /* eslint-disable */
    try {
        const idData = `${this.$route.params.id}`;
      const { data } = await api.post('easyinvoice/invoices_list_batch_detail', {
          /* eslint-disable-next-line @typescript-eslint/camelcase */
        id: idData,
      });
      const workbook = new excel.Workbook();
      workbook.created = dayjs().toDate();
      const sheet = workbook.addWorksheet('Report', { views: [{ state: 'frozen', ySplit: 1 }] });
      sheet.getRow(1).font = { bold: true };
      sheet.columns = [
        { header: 'Transaction Number', width: 20 },
        { header: 'Customer Name', width: 20 },
        { header: 'E-mail', width: 30 },
        { header: 'Created Date', width: 20 },
        { header: 'Expired Date', width: 20 },
        { header: 'Status', width: 20 },
        { header: 'Reason', width: 230 },
      ];
      data.data.forEach((item: any) => {
        sheet.addRow([
          item.transno,
          item.name,
          item.email,
          item.created_at,
          item.expiry_time,
          item.status,
          item.message,
        ]);
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer]);
      const fileURL = window.URL.createObjectURL(blob);
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      const filename = `'Report-Invoices-Bulk-Batch-Detail'-${new Date().toLocaleDateString()}.xlsx`;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
      this.loadingExport = false;
      showToast(ToastType.SUCCESS, 'Export Report', 'Export finished');
    } catch (err) {
      this.loadingExport = false;
      showToast(ToastType.FAILED,
        `Error [${(err as AxiosError).response?.status}]`, 'Failed to export Report');
    }
    /* eslint-enable */
  }
}
